export const tourText = {
  textAreaContainer: {
    title: 'AI-powered Creation',
    description: 'Type a topic and AI will generate content.',
  },
  interactiveLessons: {
    title: 'Make Lessons Interactive',
    description: 'Enhance learning with quizzes.',
  },
  draftCourses: {
    title: 'Unpublished Lessons',
    description: 'Edit and publish your lessons.',
  },
};
